import { Box, Chip, Stack, Typography } from "@mui/material";
import { TrendingUp } from "@mui/icons-material";
import { Grid } from "@mui/material";
import KpiCards from "../components/share-dashboard/KpiCards";
import ViewsBarChart from "../components/share-dashboard/ViewsBarChart";
import AccessTrendChart from "../components/share-dashboard/AccessTrendChart";
import CvSectionsCounter from "../components/share-dashboard/CvSectionsCounter";
import SharesTable from "../components/share-dashboard/SharesTable";

// Passa il cvVersionId che ti serve (es. da router param o context)
export default function ShareDashboard() {
    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "background.default", p: { xs: 2, md: 4 } }}>

            {/* Header */}
            <Stack direction="row" justifyContent="space-between" alignItems="flex-end" mb={4}>
                <Box>
                    <Typography variant="overline" color="text.secondary" fontWeight={700} letterSpacing={2}>
                        CV Manager
                    </Typography>
                    <Typography variant="h4" fontWeight={800} sx={{ fontFamily: "'DM Serif Display', Georgia, serif", lineHeight: 1.15 }}>
                        Share Dashboard
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mt={0.5}>
                        Monitora le condivisioni del tuo CV e le statistiche di accesso
                    </Typography>
                </Box>
                <Chip
                    icon={<TrendingUp />}
                    label="Statistiche live"
                    color="primary"
                    variant="filled"
                    sx={{ fontWeight: 700, borderRadius: 2 }}
                />
            </Stack>

            {/* KPI — fetch autonomo */}
            <KpiCards />

            {/* Grafici — fetch autonomi e paralleli */}
            <ViewsBarChart />
            {/*<Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid size={{ xs: 12, md: 7 }}>
                    <ViewsBarChart />
                </Grid>
                <Grid size={{ xs: 12, md: 5 }}>
                    <AccessTrendChart />
                </Grid>
            </Grid>*/}

            {/* Sezioni CV — fetch autonomo, parametrizzato */}
            {/*<CvSectionsCounter cvVersionId="1" />*/}

            {/* Tabella shares — fetch autonomo */}
            <SharesTable />

        </Box>
    );
}